import React from "react";

const AuthContext = React.createContext();

export const AuthProvider = (props) => {
  const localToken = localStorage.getItem("token");
  const localUser = JSON.parse(localStorage.getItem("user"));
  const [token, setToken] = React.useState(localToken);
  const [user, setUser] = React.useState(localUser);
  const [expire, setExpire] = React.useState(
    new Date().setMinutes(new Date().getMinutes() + 10)
  );

  React.useEffect(() => {
    setExpire(new Date().setMinutes(new Date().getMinutes() + 10));
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, setToken, user, setUser, expire }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
